import { documentTypeUtils } from '@wix/santa-editor-utils';

export default {
  allowConnectToDB: true,
  allowedMobileOnly: true,
  overrideProportionalResize: true,
  supportedInCurrentDocument: () =>
    !documentTypeUtils.isCurrentDocumentTypeIsFluidDocument(),
};
